import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BarChart(props) {
  const { hideLegend, label, heading, color } = props;
  const theme = useTheme();
  const [data, setData] = useState(null);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        [hideLegend ? "display" : "position"]: hideLegend ? false : "top",
      },
      title: {
        display: Boolean(heading),
        text: heading || "Bar Chart",
      },
    },
  };

  useEffect(() => {
    let labels = [];
    let datasets = [];
    if (!props.data?.length) {
    } else if (props.stacked) {
    } else {
      labels = props.data.map((el) => el.x);
      datasets = [
        {
          label: label || heading || "Bar Chart",
          data: props.data.map((el) => el.y),

          backgroundColor: props.data.map(
            (el, index) =>
              el.backgroundColor ||
              (color && color.includes("#")
                ? color
                : theme.palette[color || `chartColor${(index % 5) + 1}`].light)
          ),
          borderColor: props.data.map(
            (el, index) =>
              el.borderColor ||
              (color && color.includes("#")
                ? color
                : theme.palette[color || `chartColor${(index % 5) + 1}`].dark)
          ),
          borderWidth: 1,
        },
      ];
    }

    setData({
      labels,
      datasets,
    });
    // eslint-disable-next-line
  }, [props]);

  if (!data) return <></>;
  return <Bar options={options} data={data} />;
}
